import { useEffect, useState } from '@frontend/react';

type UseTaskCardAnimationProps = {
  index: number;
  isExpanded?: boolean;
};

export const useTaskCardAnimation = ({ index, isExpanded = true }: UseTaskCardAnimationProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isExpanded) {
      // Trigger animation after a delay based on index
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, index * 50);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
      return undefined;
    }
  }, [isExpanded, index]);

  const animationStyle = {
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
    transition: 'opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    willChange: 'opacity, transform',
  };

  return { animationStyle };
};
